// src/components/faq.tsx
import React, { useState } from 'react';
import { StarryBackground } from './StarryBackground';
import { ChevronDown } from 'lucide-react';

// Data for the FAQ items - easier to manage and scale
const faqData = [
  {
    question: "Who are we?",
    answer: [
      "We're simply a group of exceedingly passionate Moneroists who want to spread the message.",
      "We believe, plain and simply- Monero is a positive force for the world. We believe big banks are inherently evil establishments, and we see XMR as a pathway and tool to remediate that.",
      "We exist solely to promote the holistic solution to degeneracy we expressly believe Monero/XMR to be."
    ]
  },
  {
    question: "Why should I use XMR?",
    answer: [
      "For conservatives- it is the ultimate tool for you to resist and counterattack against the international cliques deplatforming, delegitimizing, and yes, even debanking, of you for your views.",
      "For liberals- Monero is a pathway through which you can leverage its decentralization, open and transparent nature, as the ultimate solution to oligarchy."
    ]
  },
];

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <StarryBackground />
      <main className="max-w-4xl mx-auto p-6 md:p-8 text-white">
        <header className="text-center my-12 md:my-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Frequently Asked Questions</h1>
          <p className="text-lg md:text-xl text-gray-300">
            Your questions, answered. If you don't see what you're looking for, please contact us.
          </p>
        </header>

        <section className="space-y-4">
          {faqData.map((item, index) => (
            <div key={index} className="border border-gray-700 rounded-lg overflow-hidden bg-gray-800/50 backdrop-blur-sm">
              <button
                onClick={() => handleToggle(index)}
                className="w-full flex justify-between items-center text-left p-6 hover:bg-gray-700/50 transition-colors"
              >
                <h3 className="text-xl font-semibold text-orange-300">{item.question}</h3>
                <ChevronDown
                  className={`transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                />
              </button>
              <div
                className={`transition-all duration-500 ease-in-out grid ${openIndex === index ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
              >
                <div className="overflow-hidden">
                  <div className="p-6 border-t border-gray-700 space-y-4 text-gray-300">
                    {item.answer.map((p, i) => <p key={i}>{p}</p>)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </section>
      </main>
    </>
  );
};

export default FaqPage;
